import * as React from 'react';
import { QuestionModel } from '../../models/question.model';
import getLangTranslation, { LangKey } from '../../common/lang-trans';
import * as fromConstants from '../../common/constants';
import { getBreakpoint, isRadio } from '../../common/helperFunctions';
import { McqOptionModel } from '../../models/mcq-option.model';
import { BreakPointEnum } from '../../common/constants';

interface iProps {
    question: QuestionModel,
    changeEvent: any,
    changeMcqEvent: any,
    changeMatrixEvent: any,
    changeMcqOtherEvent: any,
    language: string
}

class SurveyQuestion extends React.PureComponent<iProps> {
    public render() {
        const headingExists = (this.props.question.groupId > 0);
    
        const language = this.props.language || 'en';
        const langTrans = getLangTranslation(language);

        return (
            <React.Fragment>
                <div className={`col-sm-12 pb-5 ${headingExists ? 'pl-4' : ''}`}>
                    <label className="form-label fw-bold mb-1 lh-sm">{this.props.question.question}{this.props.question.isMandatory ? <samp className="text-danger">&nbsp;*</samp> : ''}</label>
                    {this.getInputControl(this.props.question, langTrans)}
                </div>
            </React.Fragment>
        );
    }

    private getInputControl(q: QuestionModel, langTrans: LangKey) {
        const ctrlName = '' + q.questionId;
        let errorMsg = q.errorMessage;

        if (!errorMsg || errorMsg === '')
            errorMsg = langTrans.ReauiredField;

        if (q.code === fromConstants.QuestionType_Phone) {
            return (
                <>
                    <input type="text"
                        className="form-control"
                        name={ctrlName}
                        required={this.props.question.isMandatory}
                        placeholder={q.placeholder}
                        onChange={this.handleChange}></input>
                    {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}
                </>
            );
        } else if (q.code === fromConstants.QuestionType_Email) {
            return (
                <>
                    <input type="email"
                        className="form-control"
                        name={ctrlName}
                        required={this.props.question.isMandatory}
                        pattern={q.defaultRegex}
                        placeholder={q.placeholder}
                        onChange={this.handleChange}></input>
                    {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}
                </>
            );
        } else if (q.code === fromConstants.QuestionType_MCQ) {

            return this.mcqControl( ctrlName, q, errorMsg );

        } else if (q.code === fromConstants.QuestionType_MATRIX) {

            return this.matrixControl( ctrlName, q, errorMsg );

        } else if (q.maxCharacterLimit <= 100) {
            return (
                <>
                    <input type="text"
                        className="form-control"
                        name={ctrlName}
                        required={this.props.question.isMandatory}
                        pattern={q.defaultRegex}
                        maxLength={q.maxCharacterLimit}
                        placeholder={q.placeholder}
                        onChange={this.handleChange}></input>
                    {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}
                </>
            );
        } else {

            return (
                <>
                    <textarea
                        rows={3}
                        className="form-control"
                        name={ctrlName}
                        required={this.props.question.isMandatory}
                        maxLength={q.maxCharacterLimit > 0 ? q.maxCharacterLimit : 100}
                        placeholder={q.placeholder}
                        onChange={this.handleTextAreaChange}></textarea>
                        {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}
                </>
            );
        }
    }
    
    private mcqControl(ctrlName: string, q: QuestionModel, errorMsg: string) {
        const inputType = isRadio(q.minMcqValues, q.maxMcqValues) ? 'radio' : 'checkbox';
        const col = q.mcqOptions.length > 10 ? 'col-sm-6' : 'col-sm-12';
        return <>
            {
                // render dropdown or radio/checkbox
                (inputType === 'radio' && q.mcqOptions.length > 10) 
                ? <select className="form-select"
                    name={ctrlName}
                    defaultValue=""
                    required={this.props.question.isMandatory}
                    placeholder={q.placeholder}
                     onChange={this.handleMcqSelectChange}>
                        <option value="" disabled></option>
                        {
                            q.mcqOptions.map((item, index) => {
                                return(<option key={item.mcqOptionId} value={item.mcqOptionId}>{item.option}</option>)
                            })
                        }
                    </select>
                    
                :    <div className="row">
                        { this.sortMCQ(q.mcqOptions, q.mcqOptions.length > 10).map((item, index) => {
                            let colCss = col;
                            let ctrlId = `c${ctrlName}-${item.mcqOptionId}`;
                            return (
                                <div className={colCss} key={`${q.questionId}-${index}-CheckORadio`}>
                                    <div className="form-check">

                                        <input type={inputType}
                                            className="form-check-input position-static"
                                            id={ctrlId}
                                            name={ctrlName}
                                            defaultValue={item.mcqOptionId}
                                            required={this.props.question.isMandatory}
                                            onChange={this.handleMcqChange}></input>&nbsp;
                                        <label className="form-check-label" htmlFor={ctrlId}>{item.option}</label>
                                    </div>
                                </div>
                                )})
                        }
                    </div>
            }
            
            {
            //Other Textbox
            q.mcqOptions.map((item, index) => {
                if (item.isOther && q.mcqAnswers && q.mcqAnswers.findIndex( a => a.mcqOptionId === item.mcqOptionId) >= 0) {
                    return (
                    <input key={`${q.questionId}-${index}-XOtherTxt`} type="text"
                        className="form-control"
                        name={q.questionId.toString()}
                        id={item.mcqOptionId.toString()}
                        required
                        placeholder={q.placeholder}
                        onChange={this.handleMcqOtherChange}></input>
                    );
                } else {
                    return <React.Fragment key={`${q.questionId}-${index}-COtherTxt`}></React.Fragment>
                }
            })}
            {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}

        </>
    }

    private matrixControl(ctrlName: string, q: QuestionModel, errorMsg: string) {
        if (q.matrixColumns === null || q.matrixRows === null)
            return <></>

        const textColor = "text-matrix-color";
        const breakpoint = getBreakpoint();
        const colLen = Math.floor(12 / (q.matrixColumns.length > 12 ? 12 : q.matrixColumns.length));
        return <>
                <div className={`row p-2 d-none d-md-flex bg-light ${textColor}`}>
                    <div className="col-md-4">
                        &nbsp;
                    </div>
                    <div className="col-md-8 fw-bold text-center align-self-center justify-content-evenly">
                        {/* <div className='d-flex flex-md-row flex-sm-column justify-content-evenly'> */}
                        <div className={`row row-col-md-${colLen} row-col-sm-12`}>
                            {
                                q.matrixColumns.map((c, idx) => {
                                    return (
                                        <div className={`col-12 col-md-${colLen} text-break px-1`} key={`martixColLabel-${idx}`}>
                                           {c.textEn}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            {
                q.matrixRows.map((r, i) => {
                    return (
                        <div className={`row p-2 ${textColor} ${(i%2) ? 'bg-light' : 'bg-secondary'}`} key={`martixQuestion-${r.matrixId}`}>
                            <div className={`col-12 col-md-4 align-self-center fw-bold ${ breakpoint <= BreakPointEnum.sm ? 'pb-2' : '' }`}>
                                {r.textEn}
                            </div>
                            <div className="col-12 col-md-8 align-self-center justify-content-evenly">
                                <div className="row">
                                    {
                                        q.matrixColumns.map((c, idx) => {
                                            const ctrlId = `${ctrlName}-${r.matrixId}-${c.matrixId}`;
                                            return (
                                                <div className={`col-12 col-md-${colLen} px-1`} key={`martixColCtrl-${idx}`}>
                                                    <div className={ breakpoint <= BreakPointEnum.sm ? 'form-check' : 'text-md-center' }>
                                                        <input type="radio"
                                                            className="form-check-input position-static"
                                                            id={ctrlId}
                                                            name={`${ctrlName}-${r.matrixId}`}
                                                            defaultValue={`${r.matrixId}-${c.matrixId}`}
                                                            required={this.props.question.isMandatory}
                                                            onChange={this.handleMatrixChange}></input>
                                                        <label className="form-check-label d-sm-inline d-md-none" htmlFor={ctrlId}>{c.textEn}</label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                        </div>
                    </div>)
                })
            }
            {!this.isvalue(this.props.question.isValid) && <div className="invalid-feedback d-block pt-1 pb-2">{errorMsg}</div>}
        </>
    }

    private sortMCQ(mcq:  McqOptionModel[], isTwoColumn: boolean):  McqOptionModel[] {

        let result: McqOptionModel[] = [];

        if (isTwoColumn) {

            const half = Math.ceil(mcq.length /2);

            for(let i= 0; i< mcq.length;i++){
                let idx = (i >= half ? ((i-half)*2)+1 : i * 2);
                result[idx] = mcq[i]; 
            }

            return result;
        }

        return mcq;

    }
    
    handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.props.changeEvent(e);
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.changeEvent(e);
    };

    handleMcqChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.changeMcqEvent(e);
    };

    handleMcqSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.changeMcqEvent(e);
    };

    handleMcqOtherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.changeMcqOtherEvent(e);
    };


    handleMatrixChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.changeMatrixEvent(e);
    };

    private isvalue(value: boolean): boolean {

        if (value === undefined || value === null)
            return true;

        return value;
    }
};

export default SurveyQuestion;
